export default {
    receiver: {
        title: 'Orders',
        subtitle: 'Manage your orders sent to shippers',
        newOrder: 'New Order',
        tableTitle: 'Sent Orders',
        tableDescription: 'List of all orders you have sent to shippers',
        headers: {
            orderId: 'Order ID',
            shipper: 'Shipper',
            targetWeek: 'Target Week',
            status: 'Status',
            createdAt: 'Created At',
            actions: 'Actions'
        }
    },
    sender: {
        title: 'Orders',
        subtitle: 'Manage orders received from receivers',
        tableTitle: 'Received Orders',
        tableDescription: 'List of all orders received from receivers',
        accept: 'Accept',
        reject: 'Reject',
        modify: 'Modify',
        headers: {
            orderId: 'Order ID',
            receiver: 'Receiver',
            targetWeek: 'Target Week',
            status: 'Status',
            createdAt: 'Created At',
            actions: 'Actions'
        }
    },
    list: {
        loading: 'Loading orders...',
        noOrders: 'No orders found',
        searchPlaceholder: 'Search orders...',
        filters: {
            allStatuses: 'All Statuses'
        }
    },
    detail: {
        title: 'Order Details',
        subtitle: 'View and manage order details',
        loading: 'Loading order details...',
        notFound: 'Order not found',
        backToList: 'Back to list',
        back: 'Back',
        shipper: 'Shipper',
        receiver: 'Receiver',
        targetWeek: 'Target Week',
        createdAt: 'Created At',
        respondedAt: 'Responded At',
        notes: 'Notes',
        rejectionReason: 'Rejection Reason',
        proposedChanges: 'Proposed Changes',
        modificationRequested: 'Modification Request Sent',
        modificationRequestedDescription: 'You have sent a modification request for this order. The Receiver will receive a notification and can accept or reject the proposed changes.',
        acceptChanges: 'Accept Changes',
        acceptChangesAndResend: 'Accept Changes and Resend Order',
        rejectChanges: 'Reject Changes',
        changesAcceptedMessage: 'The changes have been accepted and the order has been resent to the Shipper.',
        packingList: {
            title: 'Packing List',
            requested: 'Requested Packing List',
            provided: 'Provided Packing List',
            notSpecified: 'Not specified',
            providePlaceholder: 'Enter the provided packing list...',
            save: 'Save Packing List'
        },
        contractualInfo: {
            title: 'Contractual Information',
            contractNumber: 'Contract Number',
            contractNumberPlaceholder: 'E.g. CONTRACT-2024-001',
            contractDate: 'Contract Date',
            terms: 'Terms',
            termsPlaceholder: 'Enter contract terms...',
            notes: 'Contract Notes',
            notesPlaceholder: 'Additional notes about the contract...',
            save: 'Save Information'
        },
        orderItems: {
            title: 'Customer Order Details'
        },
        actions: {
            title: 'Actions',
            accept: 'Accept Order',
            reject: 'Reject Order',
            modify: 'Propose Changes'
        },
        rejectModal: {
            title: 'Reject Order',
            reason: 'Rejection Reason',
            reasonPlaceholder: 'Enter the reason for rejection...',
            submit: 'Confirm Rejection'
        },
        modifyModal: {
            title: 'Propose Changes',
            changes: 'Proposed Changes',
            changesPlaceholder: 'Describe the changes you want to propose...',
            submit: 'Submit Changes'
        }
    },
    form: {
        title: 'New Order',
        subtitle: 'Create a new order for a sender',
        back: 'Back',
        cancel: 'Cancel',
        submit: 'Create Order',
        saving: 'Saving...',
        senderSection: 'Sender',
        orderSection: 'Order Details',
        sender: 'Sender',
        senderPlaceholder: 'Select a sender',
        createNewSender: 'Create New Sender',
        newSenderName: 'Sender Name',
        newSenderNamePlaceholder: 'E.g. TechCorp Solutions LLC',
        newSenderEmail: 'Sender Email',
        newSenderEmailPlaceholder: 'contact@techcorp.com',
        newSenderCountry: 'Country',
        newSenderCountryPlaceholder: 'E.g. United States',
        createSender: 'Create Sender',
        shipperSection: 'Shipper',
        shipper: 'Shipper',
        shipperPlaceholder: 'Select a shipper',
        createNewShipper: 'Create New Shipper',
        newShipperName: 'Shipper Name',
        newShipperNamePlaceholder: 'E.g. TechCorp Solutions LLC',
        newShipperEmail: 'Shipper Email',
        newShipperEmailPlaceholder: 'contact@techcorp.com',
        newShipperCountry: 'Country',
        newShipperCountryPlaceholder: 'E.g. United States',
        createShipper: 'Create Shipper',
        targetWeek: 'Target Week',
        packingList: 'Requested Packing List',
        packingListPlaceholder: 'Describe in detail the requested packing list...',
        notes: 'Notes',
        notesPlaceholder: 'Additional notes about the order...',
        errors: {
            allFieldsRequired: 'All required fields must be filled',
            newSenderNotImplemented: 'Creating new senders is not yet implemented. Please select an existing sender.',
            newShipperNotImplemented: 'Creating new shippers is not yet implemented. Please select an existing shipper.',
            generic: 'An error occurred while creating the order'
        }
    }
};

